import { Routes, Route, useLocation } from 'react-router-dom';
import NotFound from './views/NotFound';
import BookingManagement from './views/Manage';
import BookingPage from './views/Book';
import HomePage from './views/Home';
import { useEffect } from 'react';

function App(){
    const {pathname} = useLocation()
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    
    return (
        <>
        <Routes>
            <Route path='/' element={<HomePage />}  />
            <Route path='/book' element={<BookingPage />} />
            <Route path='/manage' element={<BookingManagement />}  />
            <Route path='*' element={<NotFound />}  />
        </Routes>
        </>
    )
}

export default App;